import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { EmailSvg, GoogleSvg, InstagramSvg, LocationSvg, PhoneSvg } from './svg';
import ContactModal from "../modal/ContactModal";

const confetti = process.env.PUBLIC_URL + '/images/footer-confetti.png';
const logo = process.env.PUBLIC_URL + '/images/footer-logo.png';


export default function Footer() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  return (
    <div className='mt-[80px] sm:mt-[100px] bg-[#683292] rounded-t-[30px] sm:rounded-t-[44px] pt-[50px] sm:pt-[80px] px-[16px] sm:px-[32px] lg:px-[48px] relative overflow-hidden'>
        <img src={confetti} alt='confetti' className='absolute top-0 left-0 w-full object-cover z-0 pointer-events-none opacity-80' />
        <div className='max-w-[1360px] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-8 lg:gap-8 xl:gap-12 items-start relative z-10'>
            <div className='lg:col-span-4 max-w-[360px]'>
                <img src={logo} alt="rainbowtrucks" className='h-[44px] object-contain' loading='lazy'/>
                <p className='mt-[24px] text-[#FFFFFF]/85 text-[15px] font-normal leading-relaxed'>From every kulfi we serve to every opportunity we create, Rainbow Trucks is committed to building stronger, more sustainable local entrepreneurial communities.</p>
                <div className='mt-[28px] flex gap-[20px] items-center'>
                    <a href="https://www.instagram.com/fresh_kulfi/" target="_blank" rel="noreferrer" aria-label="Instagram" className="p-2.5 rounded-full bg-white/10 hover:bg-white/20 transition-all hover:scale-110">
                        <InstagramSvg size="24"/>
                    </a>
                    <a href="https://www.google.com/search?q=Rainbow+Trucks+Private+Limited" target="_blank" rel="noreferrer" aria-label="Google" className="p-2.5 rounded-full bg-white/10 hover:bg-white/20 transition-all hover:scale-110">
                        <GoogleSvg size="24"/>
                    </a>
                </div>
            </div>
            <div className='lg:col-span-3 flex flex-col gap-[20px]'>
                <h4 className='text-[#FFFFFF] text-[17px] xl:text-[18px] font-bold tracking-wide uppercase text-white/90'>Head Office</h4>
                <div className='flex gap-[16px] flex-col text-[14px] xl:text-[15px] text-[#FFFFFF]/85'>
                    <div className='flex gap-[14px] items-start'>
                        <LocationSvg className="mt-1 shrink-0" />
                        <p className='max-w-[280px] leading-relaxed'>10th Street, Ram Nagar, Puzhuthivakkam, Madipakkam, Chennai, Tamil Nadu 600091</p>
                    </div>
                    <div className='flex gap-[14px] items-center'>
                        <PhoneSvg className="shrink-0" />
                        <a href="tel:+919150013114" className='hover:text-white transition-colors'>+91 91500 13114</a>
                    </div>
                    <div className='flex gap-[14px] items-center'>
                        <EmailSvg className="shrink-0" />
                        <a href="mailto:hello@rainbowtrucks.com" className='hover:text-white transition-colors'>hello@rainbowtrucks.com</a>
                    </div>
                </div>
            </div>
            <div className='lg:col-span-2 flex flex-col gap-[20px]'>
                <h4 className='text-[#FFFFFF] text-[17px] xl:text-[18px] font-bold tracking-wide uppercase text-white/90'>Company</h4>
                <div className='flex gap-[12px] flex-col text-[#FFFAF2]/90 text-[14px] xl:text-[15px] font-medium'>
                    <a href="/#about" className="hover:text-white hover:underline transition-all">About Us</a>
                    <a href="/#franchise-options" className="hover:text-white hover:underline transition-all">Franchise Models</a>
                    <a href="/#investment" className="hover:text-white hover:underline transition-all">Investment Details</a>
                    <a href="/#our-products" className="hover:text-white hover:underline transition-all">Our Kulfis</a>
                    <a href="/#faq" className="hover:text-white hover:underline transition-all">FAQ</a>
                    <a href="/#contact" className="hover:text-white hover:underline transition-all">Get In Touch</a>
                </div>
            </div>
            <div className='lg:col-span-3 flex flex-col gap-[20px]'>
                <h4 className='text-[#FFFFFF] text-[17px] xl:text-[18px] font-bold tracking-wide uppercase text-white/90'>Legal & Support</h4>
                <div className='flex gap-[12px] flex-col text-[#FFFAF2]/90 text-[14px] xl:text-[15px] font-medium'>
                    <Link to="/privacy-policy" className="hover:text-white hover:underline transition-all">Privacy Policy</Link>
                    <Link to="/terms-of-service" className="hover:text-white hover:underline transition-all">Terms of Service</Link>
                    <p onClick={() => setIsContactModalOpen(true)} className="cursor-pointer hover:text-white hover:underline transition-all">Apply for Franchise</p>
                    <p onClick={() => setIsContactModalOpen(true)} className="cursor-pointer hover:text-white hover:underline transition-all">Bulk & Event Orders</p>
                    <a href="tel:+919150013114" className="hover:text-white hover:underline transition-all">24x7 Helpline: +91 9150013114</a>
                </div>
            </div>
        </div>
        <div className='mt-[48px] py-[21px] border-t border-white/10 text-white/70 text-[13px] font-normal text-center flex flex-col sm:flex-row items-center justify-between gap-2 max-w-[1360px] mx-auto'>
            <p>© {new Date().getFullYear()} Rainbow Trucks Private Limited. All rights reserved.</p>
            <div className='flex items-center gap-4 text-[12px] text-white/60'>
                <Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link>
                <span>&bull;</span>
                <Link to="/terms-of-service" className="hover:text-white transition-colors">Terms of Service</Link>
            </div>
        </div>
        <ContactModal 
            isOpen={isContactModalOpen} 
            onClose={() => setIsContactModalOpen(false)} 
        />
    </div>
  )
}

